export default __webpack_public_path__ + "static/media/dg_intro.4ae3fd85.png";